import React, { FC, useState } from 'react';
import { Box, Switch, Tooltip } from '@mui/material';
import SignatureModal from 'components/Modals/SignatureModal';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setIsSignatureChecked } from 'store/global/globalSlice';

const Signature: FC<{ disabled?: boolean }> = ({ disabled }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { isSignatureChecked } = useAppSelector((state) => state.global);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleSignatureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked as boolean;
        dispatch(setIsSignatureChecked(isChecked));
    };

    const onCloseModal = () => setIsOpen(false);
    const onOpenModal = () => setIsOpen(true);

    return (
        <Box>
            <Box className="signature-content">
                <Tooltip placement="top" title={t('web_app.tooltips.signature')}>
                    <Box className="signature-content-item">
                        <Box className="signature-content-item-top">
                            {t('web_app.settings.signature.btn_name')}
                            <Switch
                                checked={isSignatureChecked}
                                onChange={handleSignatureChange}
                                disabled={disabled}
                            />
                        </Box>
                        <Box className="signature-content-item-bottom">
                            <button
                                onClick={onOpenModal}
                                disabled={!isSignatureChecked || disabled}
                            >
                                {t('web_app.settings.signature.edit')}
                            </button>
                        </Box>
                    </Box>
                </Tooltip>
            </Box>
            <SignatureModal open={isOpen} onClose={onCloseModal} />
        </Box>
    );
};

export default Signature;
